import React, {Fragment} from "react";
import PropTypes from "prop-types";
import Page from "../../../../../components/BaseComponents/Page/Page";
import {FaSolidIcon} from "../../../../../components/FontAwesomeIcons";
import {TabViewItem} from "../../../../../components/BaseComponents/TabView";
import TimeoffRequestsPermessiTab from "./TimeoffRequestsPermessiTab";
import TimeoffRequestsFerieTab from "./TimeoffRequestsFerieTab";

const TAB_PERMESSI = "permessi";
const TAB_FERIE = "ferie";

export default class TimeoffRequestsModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: TAB_PERMESSI
        };
        this.activeTabColor = "#293069";
    }

    handleTabChange = tab => _ => this.setState({activeTab: tab});

    render() {
        return (
            <Fragment>
                <Page
                    title={"Richiesta permessi/ferie"}
                    leftIcon={<FaSolidIcon name={"chevron-left"}/>}
                    onLeftIconClick={this.props.onDismiss}
                    active={this.props.active}
                    content={
                        <div>
                            <div className={"d-flex bg-white sticky-top shadow-sm"}>
                                <TabViewItem
                                    onClick={this.handleTabChange(TAB_PERMESSI)}
                                    className={"py-2 text-muted d-flex align-items-center justify-content-center flex-fill " + (this.state.activeTab === TAB_PERMESSI ? " active" : "")}
                                    activeColor={this.activeTabColor}
                                >
                                    Permessi
                                </TabViewItem>
                                <TabViewItem
                                    onClick={this.handleTabChange(TAB_FERIE)}
                                    className={"py-2 text-muted d-flex align-items-center justify-content-center flex-fill " + (this.state.activeTab === TAB_FERIE ? " active" : "")}
                                    activeColor={this.activeTabColor}
                                >
                                    Ferie
                                </TabViewItem>
                            </div>

                            {
                                this.state.activeTab === TAB_PERMESSI &&
                                <TimeoffRequestsPermessiTab
                                    staffList={this.props.staffList}
                                />
                            }
                            {
                                this.state.activeTab === TAB_FERIE &&
                                <TimeoffRequestsFerieTab
                                    staffList={this.props.staffList}
                                />
                            }
                        </div>
                    }
                />
            </Fragment>
        );
    }
}

TimeoffRequestsModal.propTypes = {
    active: PropTypes.bool,
    onDismiss: PropTypes.func,
    staffList: PropTypes.array
};
